import { useState, useEffect } from 'react';
import { LoadingSpinner } from '../../Components';
import { authHeader } from '../../Helpers/auth-header';

import config from '../../config';

export function DailyStatsCardComponent() {

    const [isLoading, setIsLoading] = useState(false);
    const [dailyStats, setDailyStats] = useState([]);

    function executeGetRequest( ) {
        setIsLoading(true);
        fetch(
          `${config.apiUrl}/api/stats/daily`, 
          { method: 'GET', headers: { 'Accept': 'application/json', ...authHeader() } }
        )
        .then(res => res.json())
        .then(data => {       
            setDailyStats(data);
            setIsLoading(false);
        } )
        .catch( () => { setIsLoading(false); } );
    }

    useEffect(() => {      
        executeGetRequest();
    }, []);  

    return (<>        
            <div className="col-lg-8">
            { isLoading 
                ? <LoadingSpinner className="d-flex justify-content-center"/> 
                : <div className="modern-card">                
                    <div className="d-flex align-items-center mb-4">
                        <div className="me-3">
                            <div className="bg-primary bg-opacity-10 rounded-circle p-3">
                                <i className="bi bi-bar-chart-fill text-primary fs-4"></i>
                            </div>
                        </div>
                        <div>
                            <h5 className="mb-1 fw-semibold">Daily Statistics</h5>
                            <p className="text-muted mb-0 small">File views and volume for the last 30 days</p>
                        </div>
                    </div>    
                    { dailyStats.length > 0 
                        ? <div className="table-responsive">
                            <table className="table table-hover align-middle">
                                <thead className="table-light">
                                    <tr>
                                        <th scope="col" className="border-0 fw-semibold">
                                            <i className="bi bi-calendar3 me-2 text-muted"></i>Date
                                        </th>
                                        <th scope="col" className="border-0 fw-semibold">
                                            <i className="bi bi-eye me-2 text-muted"></i>Views
                                        </th>
                                        <th scope="col" className="border-0 fw-semibold">
                                            <i className="bi bi-hdd me-2 text-muted"></i>Volume
                                        </th>                            
                                    </tr>
                                </thead>
                                <tbody>
                                    { dailyStats.map( (row, index) => {
                                        return (
                                        <tr key={index} className="border-bottom">
                                            <td className="py-3">
                                                <span className="fw-medium">
                                                    { (new Date(row.date)).toLocaleDateString() }
                                                </span>
                                            </td>
                                            <td className="py-3">
                                                <span className="badge bg-primary bg-opacity-10 text-primary px-3 py-2">
                                                    {row.num_of_views.toLocaleString()}
                                                </span>
                                            </td>
                                            <td className="py-3">
                                                <span className="text-muted">
                                                    {Math.round(row.volume / 1024).toLocaleString()} KB
                                                </span>
                                            </td>                            
                                        </tr>
                                        );
                                    } )}                                
                                </tbody>
                              </table>
                          </div>
                        : <div className="text-center py-5">
                            <div className="mb-3">
                                <i className="bi bi-graph-up text-muted" style={{fontSize: '3rem'}}></i>
                            </div>
                            <h6 className="text-muted">No historical data found</h6>
                            <p className="text-muted small mb-0">Data will appear here once files are accessed</p>
                          </div>
                    }                                     
                </div>                
            }        
        </div>
    </>        
    );
}